import { NavLink } from "react-router-dom";

export default () => {
    return (
        <nav className="flex gap-4 padding-x bg-white py-4">
            <NavLink
                end
                className="navlink transition-all hover:text-white rounded hover:bg-primary py-1 px-2 text-sm"
                to="/dashboard"
            >
                Dashboard
            </NavLink>
            <NavLink
                end
                className="navlink transition-all hover:text-white rounded hover:bg-primary py-1 px-2 text-sm"
                to="/dashboard/orders"
            >
                Order History
            </NavLink>
            <NavLink
                end
                className="navlink transition-all hover:text-white rounded hover:bg-primary py-1 px-2 text-sm"
                to="/dashboard/account"
            >
                Account Details
            </NavLink>
        </nav>
    );
};
